import browser from '@openclassrooms/utils/browser';

class ScrollListener {
  constructor() {
    this.lastPosition = null;
    this.newPosition = null;
    this.delta = 0;
    this.scrollDownCallback = null;
    this.scrollUpCallback = null;

    browser.window.addEventListener('scroll', this.handleScroll);
  }

  getScrollDistance() {
    this.newPosition = browser.window.scrollY;

    if (this.lastPosition !== null) {
      this.delta = this.newPosition - this.lastPosition;
    }

    this.lastPosition = this.newPosition;

    return this.delta;
  }

  handleScroll = () => {
    const scrollDistance = this.getScrollDistance();

    if (scrollDistance > 0) {
      this.scrollDownCallback();
    } else if (scrollDistance < 0) {
      this.scrollUpCallback();
    }
  };

  onScrollDown = (callback) => {
    this.scrollDownCallback = callback;
  };

  onScrollUp = (callback) => {
    this.scrollUpCallback = callback;
  };

  destroy() {
    browser.window.removeEventListener('scroll', this.handleScroll);
  }
}

export default ScrollListener;
